import React, { useState, useEffect } from 'react';
import './ProductSlider.css';

const ProductSlider = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [direction, setDirection] = useState(1); // 1 for forward, -1 for backward
    const [roundCount, setRoundCount] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    const products = [
        {
            id: 1,
            name: 'Product 1',
            image: '/products/product1.png',
            description: 'High-quality pharmaceutical product'
        },
        {
            id: 2,
            name: 'Product 2',
            image: '/products/product2.png',
            description: 'Advanced medical solution'
        },
        {
            id: 3,
            name: 'Product 3',
            image: '/products/product3.png',
            description: 'Innovative healthcare product'
        },
        {
            id: 4,
            name: 'Product 4',
            image: '/products/product4.png',
            description: 'Premium quality medicine'
        },
        {
            id: 5,
            name: 'Product 5',
            image: '/products/product5.png',
            description: 'State-of-the-art pharmaceutical'
        }
    ];

    useEffect(() => {
        if (isPaused) return;

        const timer = setInterval(() => {
            setCurrentIndex(prev => {
                const nextIndex = prev + direction;
                
                // If moving forward
                if (direction === 1) {
                    if (nextIndex >= products.length - 2) {
                        setRoundCount(rc => rc + 1);
                        if (roundCount >= 1) { // After 2 rounds
                            setDirection(-1); // Change direction
                            return products.length - 3;
                        }
                    }
                    return nextIndex < products.length - 2 ? nextIndex : 0;
                }
                // If moving backward
                else {
                    if (nextIndex <= 0) {
                        setRoundCount(rc => rc + 1);
                        if (roundCount >= 1) { // After 2 rounds
                            setDirection(1); // Change direction
                            return 0;
                        }
                    }
                    return nextIndex >= 0 ? nextIndex : products.length - 3;
                }
            });
        }, 2000);

        return () => clearInterval(timer);
    }, [isPaused, direction, products.length, roundCount]);

    const nextSlide = () => {
        if (currentIndex < products.length - 3) {
            setCurrentIndex(prev => prev + 1);
        } else {
            setCurrentIndex(0);
        }
    };

    const prevSlide = () => {
        if (currentIndex > 0) {
            setCurrentIndex(prev => prev - 1);
        } else {
            setCurrentIndex(products.length - 3);
        }
    };

    return (
        <div className="product-slider">
            <div className="slider-container" 
                 onMouseEnter={() => setIsPaused(true)}
                 onMouseLeave={() => setIsPaused(false)}>
                <button className="slider-button prev" onClick={prevSlide}>
                    <i className="fas fa-chevron-left"></i>
                </button>
                <div className="products-wrapper" style={{ transform: `translateX(-${currentIndex * 33.333}%)` }}>
                    {products.map((product, index) => (
                        <div key={product.id} className="product-card">
                            <div className="product-image-container">
                                <div className="product-image">
                                    <img src={product.image} alt={product.name} />
                                </div>
                            </div>
                            <div className="product-info">
                                <h3>{product.name}</h3>
                                <p>{product.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <button className="slider-button next" onClick={nextSlide}>
                    <i className="fas fa-chevron-right"></i>
                </button>
            </div>
            <div className="slider-dots">
                {[...Array(products.length - 2)].map((_, index) => (
                    <button
                        key={index}
                        className={`dot ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => setCurrentIndex(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProductSlider;
